import { AutocompleteValue } from '@color/continuum';
import { useField } from 'formik';

import { AutocompleteField } from './AutocompleteField';
import { IFormikAutocompleteFieldProps, TAutocompleteFieldFeature } from './types';

export function FormikAutocompleteField<
  T,
  Multiple extends TAutocompleteFieldFeature = undefined,
  DisableClearable extends TAutocompleteFieldFeature = undefined,
  FreeSolo extends TAutocompleteFieldFeature = undefined,
>(props: IFormikAutocompleteFieldProps<T, Multiple, DisableClearable, FreeSolo>) {
  const { errorText, onChange, name, ...otherProps } = props;
  const [field, meta, helpers] =
    useField<AutocompleteValue<T, Multiple, DisableClearable, FreeSolo>>(name);

  const hasError = meta.touched && Boolean(meta.error);
  const { setValue, setTouched } = helpers;

  return (
    <AutocompleteField
      name={name}
      value={field.value}
      onChange={(value) => {
        setValue(value);
        onChange?.(value);
      }}
      onBlur={() => setTouched(true)}
      errorMessage={(hasError && (errorText || meta.error)) || undefined}
      {...otherProps}
    />
  );
}
